export enum SectionType {
  LANDING_HEADER = 'LANDING_HEADER',
  LANDING_HERO = 'LANDING_HERO',
  LANDING_TEXT = 'LANDING_TEXT',
  LANDING_REVIEWS = 'LANDING_REVIEWS',
  LANDING_OFFER = 'LANDING_OFFER',
  LANDING_STEPS = 'LANDING_STEPS',
  LANDING_BONUSES = 'LANDING_BONUSES',
  LANDING_FAQ = 'LANDING_FAQ',
  LANDING_FOOTER = 'LANDING_FOOTER',
  LANDING_STICKY_FOOTER = 'LANDING_STICKY_FOOTER',
  BEFORE_QUIZ_LANDING_HERO = 'BEFORE_QUIZ_LANDING_HERO',
  BEFORE_QUIZ_LANDING_FEATURES = 'BEFORE_QUIZ_LANDING_FEATURES',
  BEFORE_QUIZ_LANDING_GALLERY = 'BEFORE_QUIZ_LANDING_GALLERY',
  BEFORE_QUIZ_LANDING_BANNER = 'BEFORE_QUIZ_LANDING_BANNER',
  BEFORE_QUIZ_LANDING_REVIEWS = 'BEFORE_QUIZ_LANDING_REVIEWS',
  BEFORE_QUIZ_LANDING_STEPS = 'BEFORE_QUIZ_LANDING_STEPS',
  BEFORE_QUIZ_LANDING_TEXT = 'BEFORE_QUIZ_LANDING_TEXT',
  BEFORE_QUIZ_LANDING_FAQ = 'BEFORE_QUIZ_LANDING_FAQ',
  BEFORE_QUIZ_LANDING_FORM = 'BEFORE_QUIZ_LANDING_FORM',
  EMAIL_MODAL = 'EMAIL_MODAL',
  BANNER_TIMER = 'BANNER_TIMER',
  BANNER_TIMER_V2 = 'BANNER_TIMER_V2',
  PSYCHIC_SERVICE_V2 = 'PSYCHIC_SERVICE_V2',
  OFFER_DISCLAIMER_PRIORITY = 'OFFER_DISCLAIMER_PRIORITY',
  PARTNERS_WITH_ANIMATION = 'PARTNERS_WITH_ANIMATION',
  FAQ = 'FAQ',
  INFO = 'INFO',
  /** @deprecated  use SPECIAL_OFFER */
  OFFER = 'OFFER',
  GUIDE = 'GUIDE',
  BADGE = 'BADGE',
  BUTTON = 'BUTTON',
  QUOTE = 'QUOTE',
  HEADER = 'HEADER',
  FAQ_V2 = 'FAQ_V2',
  FAQ_V3 = 'FAQ_V3',
  BANNER = 'BANNER',
  ADDRESS_FOOTER = 'ADDRESS_FOOTER',
  RATING = 'RATING',
  REVIEWS = 'REVIEWS',
  INSIDES = 'INSIDES',
  PAYMENT = 'PAYMENT',
  PAYMENT_WITH_COUNTDOWN = 'PAYMENT_WITH_COUNTDOWN',
  EXPERTS = 'EXPERTS',
  BENEFITS = 'BENEFITS',
  BENEFITS_WITH_DESCRIPTION = 'BENEFITS_WITH_DESCRIPTION',
  GUIDE_RESULTS_PREVIEW = 'GUIDE_RESULTS_PREVIEW',
  PARTNERS = 'PARTNERS',
  GUARANTEE = 'GUARANTEE',
  HIGHLIGHTS = 'HIGHLIGHTS',
  CALENDAR_GUIDE = 'CALENDAR_GUIDE',
  PAYMENT_V2 = 'PAYMENT_V2',
  ADVANTAGES = 'ADVANTAGES',
  GUIDE_COMPATIBILITY = 'GUIDE_COMPATIBILITY',
  CARD_WITH_IMAGE_OVERLAPPED = 'CARD_WITH_IMAGE_OVERLAPPED',
  DETAILS_INSIGHTS = 'DETAILS_INSIGHTS',
  BENEFITS_READING_INCLUDES = 'BENEFITS_READING_INCLUDES',
  OFFER_MODAL = 'OFFER_MODAL',
  BENEFITS_V2 = 'BENEFITS_V2',
  MENTIONED_IN = 'MENTIONED_IN',
  SUCCESS_ORDER = 'SUCCESS_ORDER',
  UPSELL_OFFERS_V2 = 'UPSELL_OFFERS_V2',
  PROMO_CODE = 'PROMO_CODE',
  PROMO_CODE_V2 = 'PROMO_CODE_V2',
  PLAN_TIMELINE = 'PLAN_TIMELINE',
  DISCOUNT_MODAL = 'DISCOUNT_MODAL',
  PAYWALL_HEADER = 'PAYWALL_HEADER',
  INTRO_OFFER_V2 = 'INTRO_OFFER_V2',
  INTRO_OFFER_V3 = 'INTRO_OFFER_V3',
  INTRO_OFFER_V3_WITH_DISCOUNT_TAG = 'INTRO_OFFER_V3_WITH_DISCOUNT_TAG',
  INTRO_OFFER_V4 = 'INTRO_OFFER_V4',
  INTRO_OFFER_V5 = 'INTRO_OFFER_V5',
  INTRO_OFFER_V6 = 'INTRO_OFFER_V6',
  INTRO_OFFER_LEGAL = 'INTRO_OFFER_LEGAL',
  INTRO_OFFER_IOS = 'INTRO_OFFER_IOS',
  GUIDE_USER_CARD = 'GUIDE_USER_CARD',
  UPSELL_GUIDANCE = 'UPSELL_GUIDANCE',
  BLURRED_CONTENT = 'BLURRED_CONTENT',
  REVIEWS_CAROUSEL = 'REVIEWS_CAROUSEL',
  DISCOUNT_MODAL_V2 = 'DISCOUNT_MODAL_V2',
  PRECHECKOUT_MODAL = 'PRECHECKOUT_MODAL',
  NAVIGATION_HEADER = 'NAVIGATION_HEADER',
  RELATIONSHIP_PLAN = 'RELATIONSHIP_PLAN',
  PERSONALIZED_GUIDE = 'PERSONALIZED_GUIDE',
  TRIAL_CHOICE_MODAL = 'TRIAL_CHOICE_MODAL',
  TRIAL_OFFER = 'TRIAL_OFFER',
  TRIAL_OFFER_LEGAL = 'TRIAL_OFFER_LEGAL',
  TRIAL_OFFER_WITH_ONE_TIME_PAYMENT = 'TRIAL_OFFER_WITH_ONE_TIME_PAYMENT',
  SPECIAL_OFFER = 'SPECIAL_OFFER',
  INSIGHTS_DETAILS = 'INSIGHTS_DETAILS',
  INSIGHT_PREVIEW = 'INSIGHT_PREVIEW',
  /** @deprecated  use USER_ZODIAC_DETAILS_V2, USER_ZODIAC_DETAILS_V3  */
  USER_ZODIAC_DETAILS = 'USER_ZODIAC_DETAILS',
  USER_ZODIAC_DETAILS_V2 = 'USER_ZODIAC_DETAILS_V2',
  MONEY_BACK_GUARANTEE = 'MONEY_BACK_GUARANTEE',
  ADVANTAGES_WITH_EMOJI = 'ADVANTAGES_WITH_EMOJI',
  ATTACHMENT_STYLE_PROFILE = 'ATTACHMENT_STYLE_PROFILE',
  UPSELL_CONSULTATION_OFFER = 'UPSELL_CONSULTATION_OFFER',
  UPSELL_CONSULTATION_INSIGHTS = 'UPSELL_CONSULTATION_INSIGHTS',
  UPSELL_CONSULTATION_BENEFITS = 'UPSELL_CONSULTATION_BENEFITS',
  UPSELL_CONSULTATION_GUARANTEE = 'UPSELL_CONSULTATION_GUARANTEE',
  BEFORE_AFTER = 'BEFORE_AFTER',
  LEGACY_LIST = 'LEGACY_LIST',
  LEGACY_FOOTER = 'LEGACY_FOOTER',
  LEGACY_BANNER = 'LEGACY_BANNER',
  LEGACY_REVIEWS = 'LEGACY_REVIEWS',
  LEGACY_INFO_PANEL = 'LEGACY_INFO_PANEL',
  LEGACY_MEDIA_PANEL = 'LEGACY_MEDIA_PANEL',
  LEGACY_PRICE_PANEL = 'LEGACY_PRICE_PANEL',
  LEGACY_MONEY_BACK_GUARANTEE = 'LEGACY_MONEY_BACK_GUARANTEE',
  COMPATIBILITY_RARITY = 'COMPATIBILITY_RARITY',
  RESULTS_SNAPSHOT = 'RESULTS_SNAPSHOT',
  RESULTS_SNAPSHOT_V2 = 'RESULTS_SNAPSHOT_V2',
  BIRTH_CHART_HERO = 'BIRTH_CHART_HERO',
  BIRTH_FORM = 'BIRTH_FORM',
  BIRTH_CHART_ANALYSIS_HERO = 'BIRTH_CHART_ANALYSIS_HERO',
  ASTRO_ANALYSIS = 'ASTRO_ANALYSIS',
  ASTRO_ANALYSIS_V2 = 'ASTRO_ANALYSIS_V2',
  INCLUDED_BENEFITS = 'INCLUDED_BENEFITS',
  FEATURE_COMPARISON_PANEL = 'FEATURE_COMPARISON_PANEL',
  GUARANTEED_PAYMENT_SECURITY = 'GUARANTEED_PAYMENT_SECURITY',
  IMAGE = 'IMAGE',
  SCORES_CHART = 'SCORES_CHART',
  PHONE_PREVIEW = 'PHONE_PREVIEW',

  //redesign sections
  NEB_TITLE = 'NEB_TITLE',
  NEB_TEXT = 'NEB_TEXT',
  NEB_DISCLAIMER = 'NEB_DISCLAIMER',
  NEB_DISCLAIMER_TEXT = 'NEB_DISCLAIMER_TEXT',
  NEB_SPACE = 'NEB_SPACE',
  NEB_ACTION_BUTTON = 'NEB_ACTION_BUTTON',
  NEB_PAYWALL_HEADER = 'NEB_PAYWALL_HEADER',
  NEB_PARTNERS = 'NEB_PARTNERS',
  NEB_GUARANTEE = 'NEB_GUARANTEE',
  NEB_INTRO = 'NEB_INTRO',
  NEB_ADDRESS = 'NEB_ADDRESS',
  NEB_FEEDBACK_CARDS = 'NEB_FEEDBACK_CARDS',
  NEB_PERSONALIZED_GUIDE = 'NEB_PERSONALIZED_GUIDE',
  NEB_INSIGHTS_DETAILS = 'NEB_INSIGHTS_DETAILS',
  NEB_PAYMENT = 'NEB_PAYMENT',
  NEB_NEXT_BUTTON = 'NEB_NEXT_BUTTON',
  NEB_IMAGE = 'NEB_IMAGE',
  NEB_SOCIAL_PROOF = 'NEB_SOCIAL_PROOF',
  NEB_REVIEW_CARD = 'NEB_REVIEW_CARD',
  NEB_OFFER_INFO = 'NEB_OFFER_INFO',
}
